// extracted by mini-css-extract-plugin
module.exports = {"items":"style_items__12CGi"};